module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "field field-text"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.newLabel)))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state != 'field'),
      expression: "state != 'field'"
    }],
    staticClass: "secret"
  }, [_c('input', {
    staticClass: "field--input password-input",
    attrs: {
      "type": "text",
      "disabled": "",
      "id": _vm.name,
      "placeholder": _vm.placeholder
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "switch btn btn-tertiary btn-tiny btn-flat",
    on: {
      "click": _vm.stateSwitch
    }
  }, [_vm._v("\n        Edit\n      ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.state == 'field'),
      expression: "state == 'field'"
    }],
    staticClass: "real-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newValue),
      expression: "newValue"
    }],
    ref: "real-field",
    staticClass: "field--input text-input",
    attrs: {
      "type": "text",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "value": (_vm.newValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "switch icon yule-icon-close-small",
    on: {
      "click": _vm.stateSwitch
    }
  })]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "field-error"
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d14223c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/SecretField.vue
// module id = 1999
// module chunks = 0